import axios from "axios";
import NProgress from "nprogress";
import router from "@/router";
import "nprogress/nprogress.css";

NProgress.configure({ showSpinner: false });

const service = axios.create({
  baseURL: process.env.VUE_APP_OPEN,
  withCredentials: true,
  headers: {
    Referer: window.location.href,
    systemId: 20,
    platformType: "SC",
    "Cache-Control": "no-cache"
  }
});

service.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

service.interceptors.response.use(
  response => {
    NProgress.done();

    const { status, data } = response;

    if (status === 403) {
      router.push("/403");
      return false;
    }

    if (status >= 404 && status < 422) {
      router.push("/404");
      return false;
    }

    if (status <= 504 && status >= 500) {
      router.push("/500");
      return false;
    }

    /* if (data.code === 10011) {
    window.location.href = `${process.env.VUE_APP_CAS}account/login?service=${process.env.VUE_APP_APP}&systemId=20&retUrl=${window.location.href}`;
    return Promise.reject();
  } */

    return data;
  },
  error => {
    // eslint-disable-next-line
    console.log(`接口信息：${error.msg}` || "系统繁忙");
    return Promise.reject(error);
  }
);

export default service;
